const FIXTURE_TIMEZONE = 'Australia/Melbourne';

/**
 * Build a fixture timestamp anchored to today's date in Melbourne,
 * at the given wall-clock time. Pass `dayOffset` to shift by whole days
 * (e.g. `-1` for yesterday).
 *
 * @example todayAt('13:20')                     // today at 13:20 Melbourne time
 * @example todayAt('08:00', { dayOffset: -1 })  // yesterday at 08:00 Melbourne time
 */
export const todayAt = (
  time: `${number}:${number}`,
  { dayOffset = 0 }: { dayOffset?: number } = {},
): number => {
  const target = new Date(Date.now() + dayOffset * 86_400_000);

  const dateStr = new Intl.DateTimeFormat('en-CA', {
    timeZone: FIXTURE_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(target);

  const offsetPart = new Intl.DateTimeFormat('en-US', {
    timeZone: FIXTURE_TIMEZONE,
    timeZoneName: 'longOffset',
  })
    .formatToParts(target)
    .find((p) => p.type === 'timeZoneName')
    ?.value.replace('GMT', '');

  return new Date(`${dateStr}T${time}:00${offsetPart}`).getTime();
};
